import { Form, TextInput, TextAreaInput } from '../components/form/index.js';

const SectionInputs = [
  new TextInput({
    type: 'text',
    label: 'Title',
    id: 'inputTitle',
    classes: 'top',
  }),
  new TextAreaInput({
    label: 'Subtext',
    id: 'inputSubtext',
    classes: 'middle',
  }),
  new TextInput({
    type: 'number',
    label: 'Sort order',
    id: 'inputSortOrder',
    classes: 'bottom',
  }),
];

const SectionForm = new Form({
  inputs: SectionInputs,
  id: 'section-form',
});

export { SectionForm };
